import React from "react";
import UserPostsItem from "./UserPostsItem";

const UserPostsFun = (props) => {
  // console.log("user posts call ");
  // console.log(props.postFunction);
  return (
    <div>
      {props.postFunction
        .map((post) => (
          <UserPostsItem
            //postText={post.postText}
            //postImages={post.postImages}
            //postOcancerzZrbh={post.postOcancerzZrbh}
            //postDate={post.postDate}
            postFunction={post}
          />
        ))
        .reverse()}
    </div>
  );
};

export default UserPostsFun;
